/**
 * CtaFinal — formulaire email inline avant footer.
 */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { colors, fonts } from "../../styles/tokens";
import Button from "../Button";
import useScrollFadeIn from "../../hooks/useScrollFadeIn";

export default function CtaFinal() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [ref, style] = useScrollFadeIn();

  const handleSubmit = (e) => {
    e.preventDefault();
    const cleaned = email.trim();
    if (!cleaned) {
      navigate("/inscription");
      return;
    }
    // Pré-remplit l'email côté Inscription
    navigate(`/inscription?email=${encodeURIComponent(cleaned)}`);
  };

  return (
    <section style={{
      padding: "clamp(64px, 10vw, 100px) clamp(16px, 4vw, 24px)",
      background: colors.bg,
      fontFamily: fonts.body,
      maxWidth: "100vw",
      overflowX: "hidden",
    }}>
      <div ref={ref} style={{
        ...style,
        maxWidth: 800,
        margin: "0 auto",
        padding: "56px 32px",
        background: colors.surface,
        border: `1px solid ${colors.goldBorder}`,
        borderRadius: "20px",
        textAlign: "center",
        boxShadow: "0 20px 60px rgba(228,167,44,0.10)",
      }}>
        <h2 style={{
          fontFamily: fonts.heading,
          fontSize: "clamp(28px, 4vw, 42px)",
          fontWeight: 700,
          color: colors.text,
          marginBottom: "12px",
          letterSpacing: "-0.01em",
        }}>
          Votre ministère commence <span style={{ color: colors.gold }}>aujourd'hui.</span>
        </h2>
        <p style={{
          color: colors.textMuted,
          fontSize: "16px",
          maxWidth: 540,
          margin: "0 auto 32px",
          lineHeight: 1.6,
        }}>
          Rejoignez les premières communautés qui transforment leur façon de servir.
        </p>

        <form
          onSubmit={handleSubmit}
          style={{
            display: "flex",
            gap: "10px",
            maxWidth: 480,
            margin: "0 auto 16px",
            flexWrap: "wrap",
          }}
        >
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="votre@email.com"
            style={{
              flex: 1,
              minWidth: 220,
              background: colors.bg,
              color: colors.text,
              border: `1px solid ${colors.border}`,
              borderRadius: "10px",
              padding: "12px 16px",
              fontSize: "14px",
              outline: "none",
              fontFamily: fonts.body,
            }}
            onFocus={(e) => { e.target.style.borderColor = colors.gold; }}
            onBlur={(e)  => { e.target.style.borderColor = colors.border; }}
          />
          <Button type="submit" size="md">Commencer →</Button>
        </form>

        <div style={{
          color: colors.textMuted,
          fontSize: "13px",
          lineHeight: 1.6,
        }}>
          ✓ Gratuit · ✓ Sans carte bancaire · ✓ RGPD · ✓ Hébergé en Europe (Frankfurt)
        </div>
      </div>
    </section>
  );
}
